import { useAsObservableSource, useLocalStore } from 'mobx-react-lite';

import { useTranslation } from '@gem/modules/i18n';
import { usePopover } from '@gem/ui-kit';

import Tasks from 'APP/Tasks';
import { REACTION_POPOVER_HIDE_DELAY } from 'APP/constants/animations';
import { MessageViewPageType } from 'APP/main/ChatView/Messages/Messages.types';
import { useNavigateTo } from 'APP/router/hooks/useNavigateTo';
import Entities from 'STORE';

export default ({ message, messageViewPageType }) => {
  const navigateTo = useNavigateTo();
  const source = useAsObservableSource({ message });
  const { t } = useTranslation();

  const reactionsPopover = usePopover({ mouseOutTimeout: REACTION_POPOVER_HIDE_DELAY });

  const presenter = useLocalStore(() => ({
    startReply() {
      if (!source.message.group?.canSendMessages) {
        Entities.toast.show(t('moderation_disable_send_message'));
        return;
      }

      Tasks.messaging.startReplyMessage(source.message);
    },

    get isAllPinsPage() {
      return messageViewPageType === MessageViewPageType.AllPins;
    },

    get canBeReplied() {
      return source.message.canBeReplied && !presenter.isAllPinsPage;
    },

    get messageCanBeFocused() {
      return presenter.isAllPinsPage;
    },

    goToMessage() {
      if (source.message.group) {
        source.message.group.pinnedMessages.setPrevMessageIdOnFocusBased(source.message.id);

        Tasks.messaging.focusMessage({
          groupId: source.message.groupId,
          messageId: source.message.id,
          isAnimated: false,
        });
        navigateTo({ to: source.message.group.routePath });
      }
    },
  }));

  return { reactionsPopover, presenter };
};
